import { BiSolidEditAlt } from 'react-icons/bi';
import { FaEye, FaTrashAlt } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';

const RolePermissionTableLegends = () => {
  // rendering role permission table legends component here
  return (
    <div className='flex-1 flex items-center justify-end text-sm'>
      <div className='text-base-purple font-semibold flex items-center gap-1 border-r-2 border-dashed border-legal-dark-blue px-3'>
        <FaPlus className='size-4' />
        <p>Create</p>
      </div>

      <div className='text-base-cyan font-semibold flex items-center gap-1 border-r-2 border-dashed  border-legal-dark-blue px-3'>
        <FaEye className='size-4' />
        <p>Read</p>
      </div>

      <div className='text-base-light-blue font-semibold flex items-center gap-1 border-r-2 border-dashed  border-legal-dark-blue px-3'>
        <BiSolidEditAlt className='size-4' />
        <p>Update</p>
      </div>

      <div className='text-base-red font-semibold flex items-center gap-1 px-3'>
        <FaTrashAlt className='size-4' />
        <p>Delete</p>
      </div>
    </div>
  );
};

export default RolePermissionTableLegends;
